import React from 'react';
import { Award, Users, ThumbsUp, Clock } from 'lucide-react';

const TrustBar = () => {
  const stats = [
    {
      icon: Users,
      value: '5,000+',
      label: 'Happy Customers',
    },
    {
      icon: ThumbsUp,
      value: '15+',
      label: 'Years Experience',
    },
    {
      icon: Award,
      value: '100%',
      label: 'Satisfaction Rate',
    },
    {
      icon: Clock,
      value: '24/7',
      label: 'Emergency Service',
    },
  ];

  return (
    <section
      data-testid="trust-bar"
      className="bg-[#F8FAFC] py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <p className="text-sm font-medium tracking-wide uppercase text-slate-500">
            Trusted by Homeowners Across the Region
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div
              key={index}
              data-testid={`trust-stat-${index}`}
              className="text-center group"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 bg-white rounded-2xl shadow-sm mb-4 group-hover:shadow-md transition-shadow duration-300">
                <stat.icon className="w-6 h-6 text-[#0EA5E9]" />
              </div>
              <div
                className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-1"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {stat.value}
              </div>
              <div className="text-sm text-slate-500 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Certification Logos */}
        <div className="mt-12 pt-10 border-t border-slate-200">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60">
            <div className="flex items-center gap-2">
              <Award className="w-8 h-8 text-slate-400" />
              <span className="text-slate-500 font-medium">EPA Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-8 h-8 text-slate-400" />
              <span className="text-slate-500 font-medium">NATE Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-8 h-8 text-slate-400" />
              <span className="text-slate-500 font-medium">BBB A+ Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-8 h-8 text-slate-400" />
              <span className="text-slate-500 font-medium">Licensed & Bonded</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
